import React, { useState, useEffect } from 'react';
import { Button, Form, Input, Modal, Spin, Select,message} from "antd";
import { postAssignDo, getclientslist, getDoData } from '../../Services/Services';

const LifterAssFrm = (props) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [clientList, setClientList] = useState([]);
    const [lifteruserList, setlifteruserList] = useState([]);
    const [doList, setdoList] = useState([]);
    const [form] = Form.useForm();

    useEffect(() => {
        Getclientslist()
    }, [])
    const Getclientslist = async () => {
        const response = await getclientslist();
        if (response) {
            const filterLifter = response.lifter_user_list.filter(o =>o.com_name === localStorage.getItem('com_name'))
            const filterDataClient = response.client_list.filter(o =>o.com_name === localStorage.getItem('com_name'))
            setlifteruserList(filterLifter)
            setClientList(filterDataClient)
        }
    }
    const Get_Do_Details = async (id) => {
        const response = await getDoData({'client_id':id,'com_name':localStorage.getItem('com_name')});
        form.resetFields(['do_id'])
        if (response) {
            setdoList(response);
        }
    };
    const Get_Do_Id = async (id) => {
        const quantity = doList.find(do_lis => do_lis.id === id)
        form.setFieldsValue({
            'quantity':quantity.quantity
        })

    };
    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const onFinish = async (values) => {
        setLoading(true);
        Object.assign(values,{'com_name':localStorage.getItem('com_name')})
        const response = await postAssignDo(values);
        setLoading(false);
        if (response) {
            message.success('DO Assign Successful');
            const sortedArray = [...response].sort((a, b) => b.id - a.id);
            props.setassignDetails(sortedArray);
            props.setassignList(sortedArray);
            setIsModalOpen(false);
            form.resetFields();

        } else {
            message.warning('DO Assign Not Successful');
        }
    };

    return (
        <>
            <Modal
                visible={loading} // Correct prop name is visible, not open
                footer={null}
                closable={false}
                width={400}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <img src='transduniyalogo.png' alt='img' width={200} style={{ margin: "10px" }} />
                    <Spin />
                    <h2>Lifter Do Assign......</h2>
                </div>
            </Modal>

            <Button
                onClick={showModal}
                type='primary'
                ghost
                style={{
                    // float: "right",
                    margin: "10px",
                    backgroundColor: 'black',
                    color: 'white',
                    fontWeight: '600'
                }}
            >
                New Do Assign
            </Button>

            <Modal
                visible={isModalOpen} // Correct prop name is visible, not open
                onOk={handleOk}
                onCancel={handleCancel}
                footer={null}
            >
                <Form
                    form={form}
                    onFinish={onFinish}
                    layout="vertical"
                >
                    <div className=" grid grid-cols-1 sm:grid sm:grid-cols-2 sm:gap-2 m-auto px-5 sm:w-[70%]  md:w-[100%] ">
                        <Form.Item
                            name="lifter_id"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Select Lifter Name!",
                                },
                            ]}
                            label={<b>Select Lifter Name</b>}
                            style={{ padding: "2px", margin: "2px" }}
                        >
                            <Select
                                showSearch
                                placeholder="Search to Select"
                                optionFilterProp="children"


                            > {lifteruserList.map((e) => (
                                <Select.Option value={e.id}>
                                    {e.name}
                                </Select.Option>))}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            name="client_id"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Select Party Name!",
                                },
                            ]}
                            label={<b>Select Party Name</b>}
                            style={{ padding: "2px", margin: "2px" }}
                        >
                            <Select
                                showSearch
                                onChange={Get_Do_Details}
                                placeholder="Search to Select"
                                optionFilterProp="children"


                            > {clientList.map((client) => (
                                <Select.Option value={client.client_id}>
                                    {client.client_name}
                                </Select.Option>))}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            name="do_id"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Select DO Number!",
                                },
                            ]}
                            label={<b>Select DO No</b>}
                            style={{ padding: "2px", margin: "2px" }}
                        >
                            <Select
                                showSearch
                                placeholder="Search to Select"
                                optionFilterProp="children"
                                onChange={Get_Do_Id}
                            >
                                {doList.map((do_i) => (
                                    <Select.Option value={do_i.id}>
                                        {do_i.do_no}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            rules={[
                                {
                                    required: true,
                                    message: "Please Enter Quantity!",
                                },
                            ]}
                            name="quantity"
                            label={<b>Quantity</b>}
                            style={{ padding: "2px", margin: "2px" }}
                        >
                            <Input placeholder="Quantity" type="number" size="middle" disabled style={{ fontWeight: "600", color: "black" }} />
                        </Form.Item>
                        <Form.Item
                            rules={[
                                {
                                    required: true,
                                    message: "Please Enter Freight Rate!",
                                },
                            ]}
                            name="freight_rate"
                            label={<b>Freight Rate</b>}
                            style={{ padding: "2px", margin: "2px" }}
                        >
                            <Input placeholder="Freight Rate" type="number" size="middle" />
                        </Form.Item>
                        <Form.Item
                            rules={[
                                {
                                    required: true,
                                    message: "Please Enter Shortage Rate!",
                                },
                            ]}
                            name="shortage_rate"
                            label={<b>Shortage Rate</b>}
                            style={{ padding: "2px", margin: "2px" }}
                        >
                            <Input placeholder="Shortage Rate" type="number" size="middle" />
                        </Form.Item>
                        <Form.Item
                            rules={[
                                {
                                    required: true,
                                    message: "Please Enter Lifting Rate!",
                                },
                            ]}
                            name="lifting_rate"
                            label={<b>Lifting Rate</b>}
                            style={{ padding: "2px", margin: "2px" }}
                        >
                            <Input placeholder="Lifting Rate" type="number" size="middle" />
                        </Form.Item>
                    </div>
                    <Form.Item className="text-center" style={{ textAlign: 'center', marginRight: '40px' }}>
                        <Button
                            htmlType="submit"
                            style={{ color: "white", backgroundColor: 'black' }}
                        >
                            Submit
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default LifterAssFrm;
